import React from 'react';
import { usePromiseTracker } from 'react-promise-tracker';
import {LoadingCover, LoadingInner} from '../styles/loading_styles.js'
import Loader from 'react-loader-spinner';

const LoadingIndicator = props => {
const { promiseInProgress } = usePromiseTracker();
  return (
    promiseInProgress &&
    <LoadingCover >
      <LoadingInner>
        <Loader type="TailSpin" color="#2BAD60" height="150" width="150" />
      </LoadingInner>
    </LoadingCover>
    );
}

export default LoadingIndicator;
